module.exports = __webpack_public_path__ + "img/how5.f7a88632.png";